import {GET_CHECK_ORDER_ACTION_ELIGIBILITY,
GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS,
GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE,
GET_CHECK_ORDER_ACTION_ELIGIBILITY_RESET
} from '../actions';

const initialState = {
    isAllowed:'',
    statusMessage:'',
    statusCode:''
};

const CheckOrderActionEligibilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CHECK_ORDER_ACTION_ELIGIBILITY:
            return {
                ...state,
                isAllowed: '',
                statusMessage: '',
                statusCode: ''
            };
        case GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS:
            return {
                ...state,
                ...action.data,
                isAllowed: action.data?.isAllowed ?? '',
                statueMessage: action.data?.statusMessage ?? '',
                statusCode: action.data?.statusCode ?? '',
            };
        case GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE:
            return {
                ...state,
                isAllowed: '',
                statusMessage: action.data?.statusMessage ?? '',
                statusCode: action.data?.statusCode ?? ''
            };
        case GET_CHECK_ORDER_ACTION_ELIGIBILITY_RESET:
            return {
                ...state,
                isAllowed: '',
                statusMessage: '',
                statusCode: ''
            };
        default:
            return state;
    }
};

export default CheckOrderActionEligibilityReducer;
